{
  "name": "Add Bonus Countdown Perk",
  "powerupName": "CountdownStarBonus",
  "levelUpDescriptions": [
    "AddBonusCountdownPerkDescription1",
    "AddBonusCountdownPerkDescription2",
    "AddBonusCountdownPerkDescription3",
    "AddBonusCountdownPerkDescription4",
    "AddBonusCountdownPerkDescription5"
  ]
}